module.exports = __webpack_public_path__ + "img/dwedewweddw.a69280f8.png";